import { ChevronLeft, ChevronRight, Loader2, ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';

const NavigationButtons = ({
  isFirstStep,
  isReviewStep,
  canProceed,
  onBack,
  onNext,
  onAddToCart,
  addingToCart,
  priceInfo,
  pipingCost = 0,
}) => (
  <div className="mt-0 pt-0 border-t-0 pointer-events-none">
    <div className="flex items-center justify-between">
      {!isFirstStep ? (
        <Button variant="outline" onClick={onBack} className="gap-1 h-10 sm:h-11 text-sm sm:text-base rounded-full px-4 sm:px-6 bg-white pointer-events-auto" data-testid="prev-step-btn">
          <ChevronLeft className="mr-1 sm:mr-2 h-4 w-4" /> Back
        </Button>
      ) : <div />}

      {isReviewStep ? (
        <Button
          onClick={onAddToCart}
          disabled={!priceInfo || addingToCart}
          className="gap-1 bg-bush hover:bg-bush/90 text-white h-10 sm:h-11 text-sm sm:text-base rounded-full px-4 sm:px-8 pointer-events-auto"
          data-testid="add-to-cart-btn"
        >
          {addingToCart ? (
            <Loader2 className="mr-2 h-4 w-4 sm:h-5 sm:w-5 animate-spin" />
          ) : (
            <ShoppingCart className="mr-2 h-4 w-4 sm:h-5 sm:w-5" />
          )}
          Add to Cart {priceInfo && `- $${priceInfo.total_price.toFixed(0)}`}
        </Button>
      ) : (
        <Button
          onClick={onNext}
          disabled={!canProceed}
          className="gap-1 bg-bush hover:bg-bush/90 text-white h-10 sm:h-11 text-sm sm:text-base rounded-full px-4 sm:px-8 pointer-events-auto"
          data-testid="next-step-btn"
        >
          Continue <ChevronRight className="ml-1 sm:ml-2 h-4 w-4" />
        </Button>
      )}
    </div>
  </div>
);

export default NavigationButtons;
